import { useContext } from 'react';
import './cart.css';
import { cartContext } from '../App';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import HeaderOther from './header-other';
import DeliveryTime from './subcomponents/deliveryTime';
import LoginPopUp from './subcomponents/login-popup';

export default function Cart() {

    const { CartItem, removeFromCart, extraData, appliedCoupon, changeAppliedCoupon, clearAppliedCoupon } = useContext(cartContext);
    const address = Cookies.get('address') === 'undefined' || Cookies.get('address') === undefined ? 'Select Address' : Cookies.get('address');

    let name = ''
    let properAddress = ''
    let phone = ''

    // setting address properly
    if (address !== 'Select Address') {
        const add = address.split(',');
        name = add[0]
        properAddress = add[1]
        phone = add[2]
    }

    console.log('cart Items: ', CartItem);

    const navigate = useNavigate();

    //operating time
    const startTime = Number(extraData.data.startTime.split(':')[0]) > 12 ? Number(extraData.data.startTime.split(':')[0]) -12 + ":"+ extraData.data.startTime.split(':')[1] +  "PM" : Number(extraData.data.startTime.split(':')[0]) + ":" + extraData.data.startTime.split(':')[1] + "AM"
    const endTime = Number(extraData.data.endTime.split(':')[0]) > 12 ? (Number(extraData.data.endTime.split(':')[0]) - 12) + ":" + extraData.data.endTime.split(':')[1] +  "PM" : Number(extraData.data.endTime.split(':')[0]) + ":" + extraData.data.endTime.split(':')[1] + "AM"

    function handleClick(data) {
        const removeData = {
            details: data.details,
            qty: 0
        }
        removeFromCart(removeData);
        clearAppliedCoupon();
    }

    function removeCoupon() {
        clearAppliedCoupon()
    }

    const orderValue = CartItem.reduce((sum, item) => sum + Math.round(item.details.price * (100 - item.details.discount) / 100)*item.qty, 0);
    const savingsValue = CartItem.reduce((sum, item) => sum + Math.round(item.details.price * (item.details.discount) / 100)*item.qty, 0);
    const deliverCharge = orderValue>=extraData.data.minOrderValueFee || orderValue < extraData.data.minOrderValue?  0 : Number(extraData.data.deliveryFee);
    const totalValue = JSON.stringify(appliedCoupon) === '{}' ? orderValue + deliverCharge : orderValue + deliverCharge - appliedCoupon.discountPrice;
    const minOrderValueMsg = 'Minimum order Value Rs.' + extraData.data.minOrderValue

    const progressWidth = Number(Math.round(orderValue / extraData.data.minOrderValueFee * 100))
    const showFreeDelBox = extraData.data.minOrderValueFee - orderValue > 0 && extraData.data.minOrderValueFee - orderValue <= 15 ? true : false;

    //operates between

    const now = new Date()
    const hours = Number(now.getHours())
    const min = Number(now.getMinutes()) / 60
    const current = hours + min
    const start = Number(extraData.data.startTime.split(':')[0]) + Number(extraData.data.startTime.split(':')[1])/60
    const end = Number(extraData.data.endTime.split(':')[0]) + Number(extraData.data.endTime.split(':')[1]) / 60
    const alertmsg = 'We operates between ' + startTime + '-' + endTime
    // const start = 19
    // const end = 20

    function handlePlaced(e) {
        e.preventDefault();

        if (address === 'Select Address') {
            alert('Select Address first!')
        } else if(CartItem.length === 0) {
            alert('No items In Cart');
        } else if (orderValue < extraData.data.minOrderValue) {
            alert(minOrderValueMsg)
        } else {
            navigate('/payment');
        }
    }

    //close the login popup
    function handleClosePopUp() {

    }

    if (CartItem.length === 0) {
         
        return (
            <>
                <HeaderOther /> 
                <div style={{ display: 'flex', flexDirection:'column' ,justifyContent: 'center', alignItems:'center' }}>
                    <img src='/icons/empty-cart.png' alt='No Items in Cart' style={{ height: '250px', width: '250px' }} />
                    <p style={{fontSize:'14px', fontWeight:'500'}}>There are no items in the cart.</p>
                    <Link to='/' style={{textDecoration: 'none'}}><p style={{padding:'10px 15px 10px 15px', fontWeight:'600' , border:'0.15px solid #2c5f2d' ,borderRadius:'10px', backgroundColor:'rgb(237, 243, 234)', color:'#2c5f2d', fontSize:'14px'}}>Continue Shopping</p></Link>
                </div>
            </>
        );   
    }

    return (
        <>
            <HeaderOther />
            <div className='body-container'>
                {/* <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', borderBottom:'0.15px solid black', margin:'10px 0px', padding:'5px', borderRadius:'10px', backgroundColor:'white'}}>
                    <p className='heading'>My Cart</p>
                    <p className='heading'>{CartItem.length} Items</p>
                </div> */}
                
                <div className='cart-container'>
                    <div className='first-container' style={{marginTop: '10px'}}>
                        <div className='cart-heading-box'>
                            <p className='cart-heading-text'><span style={{color: '#2c5f2d', fontWeight: '600'}}>Cart review</span> &#10242;{ CartItem.length } Items</p>
                        </div>
                        {
                            CartItem.map((data, index) => (
                                <div key={ index } className='order-items'> 
                                    <Link to={`/product?productId=${data.id}&index=${index}`} style={{textDecoration:'none'}}>
                                        <div className='item-details'>
                                            <div className='item-pic'>
                                                <img className='pic' src={data.details.images[0]} alt={ data.details.title } />
                                            </div>
                                            <div className='item-title'>
                                                <p className='title-name-cart'>{data.details.title.length > 23 ? data.details.title.slice(0, 23) + "..." : data.details.title}</p>
                                                <p className='weight' style={{color:'black', paddingLeft:'0'}}>{data.details.weight}</p>
                                            </div>
                                        </div> 
                                    </Link>
                                    <div className='item-left'>
                                        <div className='item-price'>
                                            {
                                                data.details.discount > 0 &&
                                                <span className='wrong-price'><span style={{fontFamily:'Arial'}}>&#8377;</span>{Math.round(data.details.price)}</span>
                                            }
                                            <span><span style={{fontFamily:'Arial'}}>&#8377;</span>{Math.round(data.details.price * (100 - data.details.discount) / 100)} X { data.qty }</span>    
                                        </div>
                                        <button className='delete-btn' onClick={() => handleClick(data)}><img className='delete-icon' src='/delete.png' alt='delete'/></button>
                                    </div>
                                </div>
                            ))
                        }
                        
                        
                    </div>
                    {
                        JSON.stringify(appliedCoupon) !== '{}' ? (
                            <div className='cart-coupon-box'>
                                <div style={{display:'flex', flexDirection:'row', alignItems:'center', padding:'5px 10px'}}>
                                    {/* <img src='/icons/discount.png' alt='discount' style={{ width: '35px', height: '35px' }} /> */}
                                    <div>
                                        <p style={{ margin: '5px', fontSize: '14px' }}><span style={{color:'green', fontWeight:'500'}}><span style={{fontFamily:'Arial'}}>&#8377;</span>{appliedCoupon.discountPrice}</span> Saved with code { appliedCoupon.code }</p>
                                        <Link to='/coupon' style={{textDecoration:'none'}}><p style={{margin:'5px', fontSize:'12px', color:'gray'}}>View all Coupons &#62;</p></Link>
                                    </div>
                                </div>
                                <p
                                    style={{ fontSize: '12px', color: 'rgb(186, 58, 58)', marginRight: '10px', fontWeight: '500', border: '0.15px solid rgb(186, 58, 58)', padding: '5px', borderRadius: '7px', backgroundColor: 'rgb(246, 232, 232)' }}
                                    onClick={removeCoupon}>
                                    remove
                                </p> 
                            </div>
                        ) : (
                            <Link to='/coupon' className='cart-coupon-box'> 
                                <div style={{display:'flex', flexDirection:'row', alignItems:'center', padding:'5px 10px'}}>
                                    <img src='/icons/discount.png' alt='discount' style={{ width: '35px', height: '35px' }} />
                                    <div>
                                        <p style={{margin:'5px', fontSize:'14px', fontWeight: 600}}>Coupons & Offers</p>
                                        <p style={{margin:'5px', fontSize:'12px'}}>Have a coupon ? Apply Here.</p>
                                    </div>
                                </div>
                                <img src='/icons/right-arrow.png' alt='discount' style={{ width: '15px', height: '15px', padding:'5px 10px' }} /> 
                            </Link>
                        )
                    }
                    <div className='last-container'>
                        <p className='c-bill-head'>Bill details</p>
                        <div className='order-value'>
                            <div className='c-bill-box'>
                                <img src='/icons/receipt.png' className='c-bill-icons' />
                                <p className='item-total-margin'>Items total </p>
                            </div>
                            <p className='item-total-margin'><span style={{fontFamily:'Arial'}}>&#8377;</span>{orderValue}</p>
                        </div>
                        <div className='order-value'>
                            <div className='c-bill-box'>
                                <img src='/icons/discount-mini.png' className='c-bill-icons' />
                                <p className='item-total-margin'>Discount </p>
                            </div>
                            <p className='item-total-margin' style={{color: 'green'}}>-<span style={{fontFamily:'Arial'}}>&#8377;</span>{savingsValue}</p>
                        </div>
                        {
                            JSON.stringify(appliedCoupon) !== '{}' && 
                            <div className='order-value'>
                                <div className='c-bill-box'>
                                    <img src='/icons/discount-mini.png' className='c-bill-icons' />
                                    <p className='item-total-margin'>Coupon </p>
                                </div>
                                <p className='item-total-margin' style={{color: 'green'}}>-<span style={{fontFamily:'Arial'}}>&#8377;</span>{appliedCoupon.discountPrice}</p>
                            </div>
                        }
                        <div className='delivery'>
                            <div className='c-bill-box' style={{alignItems: 'flex-start'}}>
                                <img src='/icons/delivery-truck.png' className='c-bill-icons' style={{marginTop: '5px'}}/>
                                <p className='item-total-margin-final'>
                                    Delivery fee
                                    <span style={{ display: 'block', fontSize: '12px', color: 'rgb(110, 110, 110)' }}>Free delivery above <span style={{ fontFamily: 'Arial' }}>&#8377;</span>{extraData.data.minOrderValueFee}</span>
                                </p>
                            </div>
                            {
                                deliverCharge === 0 ?
                                    <p style={{color:'green', fontFamily:'Roboto, Arial', fontSize:'14px'}}>Free <span className='item-total-margin-final' style={{textDecoration:'line-through', color: 'black'}}><span style={{fontFamily:'Arial'}}>&#8377;</span>{extraData.data.deliveryFee}</span></p> :
                                    <p className='item-total-margin-final'><span style={{fontFamily:'Arial'}}>&#8377;</span>{deliverCharge}</p>
                            }
                            
                        </div>

                        <div className='order-total' style={{borderTop: '1px solid black'}}>
                            <p className='item-total-margin' style={{fontSize: '16px'}}>Order total </p>
                            <p className='item-total-margin'><span style={{fontFamily:'Arial', fontSize: '16px'}}>&#8377;</span>{totalValue}</p>
                        </div>
                    </div>    
                </div>
                {/* To make delivery free */}
                {
                    (showFreeDelBox || orderValue < extraData.data.minOrderValue) && 
                    <div className='delivery-free-box'>
                        <div>
                                <p style={{ margin: '10px 0 0 10px', fontWeight: '400', color: 'rgb(79, 78, 78)', fontSize: '14px' }}>Add <span style={{color:'#2c5f2d', fontSize:'14px', fontWeight:'bold'}}><span style={{fontFamily:'Arial'}}>&#8377;</span>{extraData.data.minOrderValueFee - orderValue}</span> more to  get <span style={{fontWeight:'bold', color:'#2c5f2d'}}>Free</span> Delivery </p>
                            <div style={{margin:'0 0 0 10px'}}>
                                <p style={{margin:'5px 0 2px 0', fontWeight:'400', fontSize:'14px'}}><span style={{fontFamily:'Arial'}}>&#8377;</span>{orderValue}/{extraData.data.minOrderValueFee}</p>
                                <div style={{ width: '100%', height: '5px', border: '0.15px solid green', borderRadius:'4px', margin:'0 0 10px 0' }}>
                                    <div style={{width:`${progressWidth}%`, height:'5px', backgroundColor:'green', borderRadius:'4px'}}></div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <Link to='/' className='add-more-items-link'>+ ADD ITEMS</Link>
                        </div>
                    </div>
                }
                

                <div className='address-box'>

                    {
                        address === 'unserviceable' ? (
                            <>    
                                <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', margin:'0 10px 0 10px', alignItems:'baseline'}}>
                                    <p className='address-head' style={{marginBottom:'0'}} >Delivering To</p>
                                    <Link to='/address-list' className='delivering-loc' style={{margin:'0'}}><p className='change-add' style={{borderRightWidth: '0.7px'}} >Change Address</p></Link>
                                </div>
                                <p className='delivering-loc' style={{ color: 'gray', marginBottom:'5px' }}>Oops! Service unavailable at this address.</p>
                                <p className='delivering-loc' style={{ color: 'gray', marginTop:'5px' }}> Coming soon!</p>
                            </>    
                        ):(
                            address === 'Select Address' ?
                                <>    
                                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', margin:'0 10px 0 10px', alignItems:'baseline'}}>
                                        <DeliveryTime />
                                        <Link to='/address-list' className='delivering-loc' style={{margin:'0'}}><p className='change-add' style={{borderRightWidth: '0.7px'}} >Add Address</p></Link>
                                    </div>
                                    <p className='delivering-loc' style={{ color: 'gray' }}>No Address Found</p>
                                </> :
                                <>
                                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', margin:'0 10px 0 10px', alignItems:'baseline'}}>
                                        <DeliveryTime />
                                        <Link to='/address-list' className='delivering-loc' style={{margin:'5px'}}><p className='change-add' style={{borderRightWidth: '0.7px'}}>Change Address</p></Link>
                                    </div>
                                    <div style={{marginBottom:'10px'}}>
                                        <p className='proper-add'>{ name },</p>
                                        <p className='proper-add'>{ properAddress }</p>
                                        <p className='proper-add' >{ phone }</p>
                                        
                                    </div>
                                </>
                        )
                    }     

                </div>
                <div className='open-box-delivery-container'>
                    <img src='/icons/carton-box.png' alt='open-box-logo' style={{width:'45px', height:'45px', margin:'5px 5px 0 10px'}}/>
                    <div>
                        <p className='item-total-margin' style={{ fontSize: '16px', fontWeight:'bold'}}>Shop confidently with Open Box Delivery</p>
                        <p className='item-total-margin' style={{ fontSize: '12px', marginRight:'5px' }}>
                            Our agent will <b>open the package</b> at your doorstep,
                            kindly <b>check and return</b> for damaged or incorrect item, and report any missing item at the doorstep only.
                        </p>
                    </div>                    
                </div>
                <div className='address-box' style={{marginBottom:'70px'}}>
                    {
                        start === end ? (
                            <>
                                <p className='item-total-margin' style={{textAlign:'center', fontSize: '16px', fontWeight:'500'}}>We're Closed Now!</p>
                                <p className='item-total-margin' style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'bold', color: 'green' }}>Come back Tommorrow at { startTime }</p>
                            </>
                        ) : (
                            <>
                                {/* <p className='item-total-margin' style={{textAlign:'center', fontSize: '16px', fontWeight:'500'}}>Currently, We're Operating</p>
                                <p className='item-total-margin' style={{textAlign:'center', fontSize: '18px', fontWeight: 'bold', color:'green'}}>{startTime} <span style={{color:'gray'}}>to</span> { endTime}</p> */}
                            </>
                        )
                    }
                </div>
                {
                    start === end ? (
                        <div className='cart-bottom-payment-btn-style'>
                            <div className='cart-bottom-btns' style={{fontSize:'16px', backgroundColor:'gray', borderColor:'gray'}}>CLOSED TODAY</div>
                        </div>
                        ): (
                            address === 'unserviceable' ? (
                                <div className='cart-bottom-payment-btn-style'><div className='cart-bottom-btns' style={{fontSize:'16px', backgroundColor:'gray', borderColor:'gray'}}>UNSERVICEABLE AREA</div></div>
                                ): (
                                    orderValue >= extraData.data.minOrderValue ?
                                        address === 'Select Address' ? (
                                            <div className='cart-bottom-payment-btn-style'>
                                                <Link to='/location-picker' style={{textDecoration:'none', color:'white', width:'90%' }}><div className='cart-bottom-btns'>ADD ADDRESS</div></Link>
                                            </div>
                                        ) :  
                                        (
                                            <div className='cart-bottom-payment-btn-style'>
                                                <div style={{fontSize:'16px', fontWeight:'bold', color:'black'}}>
                                                    TOTAL - <span style={{ fontFamily: 'Arial' }}>&#8377;</span>{totalValue}
                                                </div>
                                                <div className='cart-bottom-btns' onClick={handlePlaced} style={{ fontSize: '16px' }}>
                                                    Pay on Delivery
                                                </div>  
                                            </div>
                                        ) :
                                        <div className='cart-bottom-payment-btn-style'>
                                            <button className='cart-bottom-btns' style={{ fontSize: '16px', backgroundColor: 'rgb(186, 58, 58)', borderColor:'rgb(186, 58, 58)' }}>
                                                Minimum Order Value - <span style={{ fontFamily: 'Arial', marginLeft:'5px' }}>&#8377;</span>{extraData.data.minOrderValue}
                                            </button>
                                        </div>
                                )
                        )
                }
                
                {/* <button className='order-place' style={{fontSize:'16px', backgroundColor:'green', fontWeight:'bold'}}>OPENING TOMMORROW</button> */}
            </div>
        </>
       );
            
}